<div [formGroup]="form">
  <app-password-strength-bar
    [passwordToCheck]="f.password.value"
    [barLabel]="'Password strength:'"
  ></app-password-strength-bar>

  <div
    class="input-container"
    style="margin-top: 1.25rem"
  >
    <span class="input-label">Password</span>
    <app-password-input formControlName="password"></app-password-input>
    <span
      class="error"
      *ngIf="f.password.touched && form.hasError('missingUppercase')"
    >Please enter at least 1 uppercase letter.</span>
    <span
      class="error"
      *ngIf="f.password.touched && form.hasError('missingLowercase')"
    >Please enter at least 1 lowercase letter.</span>
    <span
      class="error"
      *ngIf="f.password.touched && form.hasError('missingNumber')"
    >Please enter at least 1 number.</span>
    <span
      class="error"
      *ngIf="f.password.touched && form.hasError('missingSpecialChar')"
    >Please enter at least 1 special character.</span>
    <span
      class="error"
      *ngIf="f.password.touched && form.hasError('minLength')"
    >Please enter at least 8 characters.</span>
  </div>

  <div class="input-container">
    <span class="input-label">Confirm Password</span>
    <app-password-input formControlName="confirmPassword"></app-password-input>
    <span
      class="error"
      *ngIf="f.confirmPassword.touched && form.hasError('notSame')"
    >Passwords do not match.</span>
  </div>
</div>